import { ValidationStatus } from './mfe-common.interfaces';

export interface PersonalInfoClientGetData {
  isInformationCorrect: IsInformationCorrect;
  personalInfo: ClientInfo;
  validationStatus: ValidationStatus;
}

interface ClientInfo {
  affiliationStartDate: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  birthDate: string;
  citizenshipStatus: string;
  gender: string;
  countryOfCitizenship: string;
  suffix: string;
  ssn?: string;
}

enum IsInformationCorrect {
  YES = 'Yes',
  NO = 'No',
}
